import { render, staticRenderFns } from "./view-attachment.component.vue?vue&type=template&id=d850f01c&"
import script from "./view-attachment.component.vue?vue&type=script&lang=ts&"
export * from "./view-attachment.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports